export default "__VITE_ASSET__a31d5fde__"